import React, { useState, useEffect } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import AssetsSection from './AssetsSection';
import TextSection from './TextSection';
import './ZoneDesign.css';

const ZoneDesignSection = (props) => {
	const [tab, setTab] = useState([]);
	const [tabName, setTabName] = useState();
	const [selectedZone, setSelectedZone] = useState({});
	const [zoneAssets, setZoneAssets] = useState();
	const [assetGroupList, setAssetGroupList] = useState();
	const [threadWebColor, setThreadWebColor] = useState();
	const [defaultFont, setDefaultFont] = useState({});

	useEffect(() => {
		let threadColorId =
			props.designSettings &&
			props.designSettings.data &&
			props.designSettings.data.threadColorId;
		if (threadColorId) {
			let color =
				props.colorList &&
				props.colorList.find((col) => col.colorId === threadColorId);
			setThreadWebColor(color);
		}
		let font = (props.designSettings &&
			props.designSettings.data &&
			props.designSettings.data.font) || '';
		let pulseFont = (props.designSettings &&
			props.designSettings.data &&
			props.designSettings.data.pulseFont) ||'';
		setDefaultFont({font,pulseFont});
	}, [props.designSettings]);

	useEffect(() => {
		setSelectedZone(props.selectedZone);
		let decorTypes = props.selectedZone.decorTypes;
		let tabs = [];
		if (
			decorTypes &&
			(decorTypes.includes('text-v') || decorTypes.includes('text-h'))
		) {
			tabs.push({ tabTitle: 'TEXT', key: 'text' });
		}
		if (decorTypes && decorTypes.includes('graphic')) {
			tabs.push(
				{ tabTitle: 'SCHOOL ASSETS', key: 'schoolAsset' },
				{ tabTitle: 'Graphics', key: 'graphic' }
			);
		}
		let decorTypeData =
			(props.selectedZone &&
				props.selectedZone.data &&
				props.selectedZone.data.decorType) ||
			'';
		let selectedTab = '';
		if (decorTypeData === 'graphic') {
			let assetId =
				(props.selectedZone &&
					props.selectedZone.data &&
					props.selectedZone.data.assetId) ||
				'';
			let assets = [
				...(props.zoneAssets && props.zoneAssets.graphics),
				...(props.zoneAssets && props.zoneAssets.schoolAsset),
			];
			let selectedAsset =
				(assetId &&
					assets.find((asset) => asset && asset.assetId === assetId)) ||
				null;
			if (selectedAsset) {
				if (selectedAsset.customerNumber === '-999') {
					selectedTab = 'graphic';
				} else {
					selectedTab = 'schoolAsset';
				}
			} else {
				selectedTab = 'graphic';
			}
		} else if (decorTypeData === 'text-v' || decorTypeData === 'text-h') {
			selectedTab = 'text';
		}
		setTab([...tabs]);
		setTabName(selectedTab || (tabs[0] && tabs[0].key));
	}, [props.selectedZone, props.zoneAssets]);

	useEffect(() => {
		let excludeList =
			(props.designSettings && props.designSettings.graphicExcludeList) || [];
		let graphics = [...(props.zoneAssets && props.zoneAssets.graphics)];
		graphics =
			graphics &&
			graphics.filter((asset) => !excludeList.includes(asset.assetId));
		let schoolAssets = [...(props.zoneAssets && props.zoneAssets.schoolAsset)];
		schoolAssets =
			schoolAssets &&
			schoolAssets.filter((asset) => !excludeList.includes(asset.assetId));
		setZoneAssets({ schoolAsset: schoolAssets, graphics });
	}, [props.zoneAssets]);

	useEffect(() => {
		if (tabName === 'graphic') {
			let assetGroup =
				props.assetGroups &&
				props.assetGroups.filter((asset) => {
					return asset.groupCategory === 'StockStoleAssets';
				});
			assetGroup =
				(assetGroup && assetGroup.sort((a, b) => a.sort - b.sort)) || [];
			let excludeList =
				(props.designSettings && props.designSettings.decorGroupExcludeList) ||
				[];
			assetGroup =
				assetGroup &&
				assetGroup.filter((asset) => !excludeList.includes(asset.groupCode));
			setAssetGroupList(assetGroup);
		} else if (tabName === 'schoolAsset') {
			let assetGroup =
				props.assetGroups &&
				props.assetGroups.filter((asset) => {
					return asset.groupCategory === 'SchoolStoleAssets';
				});
			setAssetGroupList(assetGroup);
		}
		props.getTabName(tabName);
	}, [props.assetGroups, tabName]);

	useEffect(()=>{
		let status = {...props.zoneTextStatus}
		delete status[selectedZone.zoneCode];
		props.setZoneTextStaus(status)
	},[tabName])

	const updateZoneDetails = (data) => {
		let zone = { ...selectedZone };
		zone.data = { ...data };
		setSelectedZone({ ...zone });
		props.updateZoneData(zone, selectedZone.zoneCode);
	};

	return (
		<Tabs
			fill
			justify
			activeKey={tabName}
			transition={false}
			id='noanim-tab-example'
			onSelect={(k) => setTabName(k)}
			unmountOnExit={true}>
			{tab &&
				tab.map((nav, index) => (
					<Tab eventKey={nav.key} title={nav.tabTitle} key={index}>
						{nav.tabTitle === 'TEXT' ? (
							<TextSection
								zone={selectedZone}
								updateZoneDetails={updateZoneDetails}
								key={selectedZone.zoneCode}
								stoleMeta={props.stoleMeta}
								stolePreview={props.stolePreview}
								fontList={props.fontList}
								getFontList={props.getFontList}
								defaultFont={defaultFont}
								zoneImagePath={props.zoneImagePath}
								setZoneImagePath={props.setZoneImagePath}
								setZoneTextStaus={props.setZoneTextStaus}
							/>
						) : (
							<AssetsSection
								title={nav.tabTitle}
								displayItemList={
									nav.key === 'schoolAsset'
										? zoneAssets.schoolAsset
										: zoneAssets.graphics
								}
								selectedId={
									(selectedZone &&
										selectedZone.data &&
										selectedZone.data.assetId) ||
									''
								}
								updateZoneDetails={updateZoneDetails}
								assetGroupList={assetGroupList}
								threadWebColor={threadWebColor}
								tabName={tabName}
								key={selectedZone.zoneCode}
								stoleMeta={props.stoleMeta}
							/>
						)}
					</Tab>
				))}
		</Tabs>
	);
};

export default React.memo(ZoneDesignSection);
